module.exports = __webpack_public_path__ + "static/attractions-2.fb83c51f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/attractions-2.jpg
// module id = 484
// module chunks = 249749550194671